import VenueMarketingOptIn from './VenueMarketingOptIn';

export default VenueMarketingOptIn;
